<template>
  <div :class="$style.container">
    <!-- 페이지 헤더 -->
    <div :class="$style.pageHeader">
      <div :class="$style.pageHeaderLeft">
        <button :class="$style.headerBackButton" @click="$router.back()" title="뒤로가기">←</button>
        <h1 :class="$style.pageTitle">마이페이지</h1>
      </div>
      <div :class="$style.pageHeaderRight">
        <button :class="$style.headerIconButton" @click="goToCalendar" title="달력 보기">
          <img :src="require('@/assets/images/calendar_month.png')" alt="달력" :class="$style.headerIconImg" />
        </button>
        <button :class="$style.headerIconButton" @click="goToNotifications" title="알림">
          <img :src="require('@/assets/images/alarms_gray.png')" alt="알림" :class="$style.headerIconImg" />
          <span v-if="userStore.isLogin && unreadNotificationCount > 0" :class="$style.headerAlarmBadge"></span>
        </button>
      </div>
    </div>

    <div :class="$style.profileCard">
      <div :class="$style.profileMainRow">
        <div :class="$style.profileImageColumn">
          <ProfileImageUploader :artist-name="userStore.nickname || 'User'" :profile-image="profileImage"
            :show-controls="true" mode="user" :user-email="userStore.email" :loading="profileLoading"
            @image-updated="handleImageUpdated" @image-removed="handleImageRemoved" :size="'120px'" />
        </div>

        <div :class="$style.profileInfoColumn" @click="goToMyInfo">
          <!-- 사용자명 -->
          <div v-if="profileLoading" :class="$style.usernameSkeleton"></div>
          <h1 v-else :class="$style.username" style="margin-bottom: 0px;">
            {{ userStore.nickname || "닉네임" }}
            <!-- <button type="button" :class="$style.editNicknameButton" @click="editProfile" aria-label="닉네임 수정"
              title="닉네임 수정">
              <svg :class="$style.editNicknameIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path
                  d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zm2.92 2.83H5v-.92l8.06-8.06.92.92L5.92 20.08zM20.71 7.04a1.003 1.003 0 0 0 0-1.42L18.37 3.29a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.83z" />
              </svg>
            </button> -->
          </h1>

          <!-- 핸들/ID -->
          <div v-if="profileLoading" :class="$style.handleSkeleton"></div>
          <div v-else :class="$style.handleContainer" style="margin-bottom: 0px;">
            <span :class="$style.handle"> {{ userStore.email || "user@example.com" }}</span>
          </div>

          <!-- 상세 링크 -->
          <a v-if="!profileLoading && userDetailLink" :href="userDetailLink" target="_blank" rel="noopener noreferrer"
            :class="$style.detailLinkButton">
            <!-- <img src="@/assets/images/xlogowhite.png" alt="X" :class="$style.detailLinkXIcon" /> -->
            <span>@{{ userDetailLink.replace(/^https?:\/\/(www\.)?x\.com\/?/, '') }}</span>
          </a>
        </div>

        <!-- 버튼들 -->
        <div v-if="profileLoading" :class="$style.profileActionSkeletonWrap"></div>
        <div v-else :class="$style.profileActionColumn" @click="goToMyInfo">
          <button :class="[$style.actionButton, $style.infoListActionButton]">
            <span :class="$style.chevronIcon">›</span>
          </button>
        </div>
      </div>

      <!-- 다가오는 공연 섹션 스켈레톤 -->
      <div v-if="profileLoading" :class="$style.upcomingSectionSkeleton">
        <div :class="$style.upcomingTitleSkeleton"></div>
        <div :class="$style.upcomingCardSkeleton"></div>
      </div>

      <!-- 다가오는 공연 섹션 -->
      <div v-else-if="!userStore.isBlocked" :class="$style.upcomingSection">
        <div :class="$style.upcomingSectionHeader">
          <h3 :class="$style.upcomingSectionTitle">다가오는 공연</h3>
          <button v-if="upcomingTicket && upcomingTicket._type === 'reservation'" :class="$style.upcomingMoreButton"
            @click="$router.push('/my-reservations')">예매내역 ›</button>
          <button v-else-if="upcomingTicket" :class="$style.upcomingMoreButton"
            @click="$router.push('/my-reservations')">내 예매내역 ›</button>
        </div>

        <div v-if="loadingTicket" :class="$style.upcomingTicketSkeleton"></div>

        <div v-else-if="upcomingTicket" :class="$style.upcomingTicketCard"
          @click="upcomingTicket._type === 'reservation' ? $router.push('/my-reservations') : $router.push(`/live/${upcomingTicket._liveId}`)">
          <img v-if="upcomingTicket._posterUrl" :src="upcomingTicket._posterUrl" alt="공연 포스터"
            :class="$style.upcomingPoster" />
          <div v-else :class="[$style.upcomingPoster, $style.upcomingPosterEmpty]">🎟</div>
          <div :class="$style.upcomingTicketInfo">
            <div :class="$style.upcomingTicketTitle">{{ upcomingTicket._title }}</div>
            <div :class="$style.upcomingTicketMeta">
              <span v-if="upcomingTicket._date">{{ upcomingTicket._date }}</span>
              <span v-if="upcomingTicket._date && upcomingTicket._place" :class="$style.upcomingDot">·</span>
              <span v-if="upcomingTicket._place">{{ upcomingTicket._place }}</span>
            </div>
            <!-- 예매 배지 (MyReservations와 동일한 통합 상태 기준) -->
            <div v-if="upcomingTicket._type === 'reservation'" :class="$style.upcomingBadgeRow">
              <span v-if="upcomingTicket.isInviteTicket" :class="[$style.upcomingStatusBadge, $style.badge_invite]">🎟
                초대권</span>
              <span v-else :class="[$style.upcomingStatusBadge, $style[getUpcomingUnifiedStatusKey(upcomingTicket)]]">
                {{ getUpcomingUnifiedStatusText(upcomingTicket) }}
              </span>
              <span v-if="!upcomingTicket.isInviteTicket" :class="$style.upcomingQty">{{ upcomingTicket.quantity
              }}매</span>
            </div>
            <!-- 찜/일반 공연 배지 -->
            <div v-else :class="$style.upcomingBadgeRow">
              <span v-if="upcomingTicket._type === 'liked'" :class="[$style.upcomingStatusBadge, $style.badge_liked]">❤️
                찜한 공연</span>
              <span v-else :class="[$style.upcomingStatusBadge, $style.badge_any]">🎵 공연 정보</span>
            </div>
          </div>
          <span :class="$style.upcomingChevron">›</span>
        </div>

        <div v-else :class="$style.upcomingEmpty">
          예정된 공연이 없습니다
        </div>
      </div>

      <div v-else :class="$style.blockedMessage">
        🚫 차단된 유저
      </div>
    </div>

    <!-- 탭 구조 -->
    <div :class="$style.tabContainer">
      <div v-if="profileLoading" :class="$style.tabHeaderSkeleton">
        <div :class="$style.tabButtonSkeleton"></div>
        <div :class="$style.tabButtonSkeleton"></div>
      </div>
      <div v-else :class="$style.tabHeader">
        <button :class="[$style.tabButton, { [$style.activeTab]: activeTab === 'lives' }]" @click="switchTab('lives')">
          공연
        </button>
        <button :class="[$style.tabButton, { [$style.activeTab]: activeTab === 'artists' }]"
          @click="switchTab('artists')">
          아티스트
        </button>
      </div>

      <!-- 탭 콘텐츠 -->
      <div :class="$style.tabContent">
        <!-- 찜한 공연 탭 -->
        <div v-if="activeTab === 'lives'" :class="$style.liveTab">
          <div v-if="loadingLives" :class="$style.loading">
            <div :class="$style.spinner"></div>
            <p>찜한 공연을 불러오는 중...</p>
          </div>

          <div v-else-if="likedLives.length === 0" :class="$style.emptyState">
            <div :class="$style.emptyIcon">🎵</div>
            <h3>찜한 공연이 없습니다</h3>
            <p>마음에 드는 공연을 찜해보세요!</p>
          </div>

          <div v-else :class="$style.liveList">
            <PerformanceCard v-for="live in likedLives" :key="live.id" :performance="live" :show-like-button="true"
              :is-liked="true" @click="goToLiveDetail" @like-toggle="unlikeLive" />
          </div>
        </div>

        <!-- 찜한 아티스트 탭 -->
        <div v-if="activeTab === 'artists'" :class="$style.artistTab">
          <div v-if="loadingArtists" :class="$style.loading">
            <div :class="$style.spinner"></div>
            <p>찜한 아티스트를 불러오는 중...</p>
          </div>

          <div v-else-if="likedArtists.length === 0" :class="$style.emptyState">
            <div :class="$style.emptyIcon">🎤</div>
            <h3>찜한 아티스트가 없습니다</h3>
            <p>좋아하는 아티스트를 찜해보세요!</p>
          </div>

          <div v-else :class="$style.artistList">
            <ArtistCard v-for="artist in likedArtists" :key="artist.name" :artist="artist" :is-liked="true"
              :show-like-button="true" @like-toggle="unlikeArtist" />
          </div>
        </div>
      </div>
    </div>

    <!-- 아티스트 카드 모달 -->
    <ArtistCardModal :isVisible="artistCardModalVisible" :userDetailLink="userDetailLink" :userStore="userStore"
      @close="closeArtistCardModal" @artist-card-updated="handleArtistCardUpdated" />

  </div>
</template>

<script>
import { useUserStore } from "@/store/user";
import {
  collection,
  getDocs,
  query,
  where,
  documentId,
} from "firebase/firestore";
import { ref as storageRef } from "firebase/storage";
import { getDownloadURL } from "@/utils/storageWithNavigation";
import { firestore, storage } from "/firebaseConfig";
import ProfileImageUploader from "@/components/ProfileImageUploader.vue";
import ArtistCard from "@/components/ArtistCard.vue";
import ArtistCardModal from "@/components/modal/ArtistCardModal.vue";
import PerformanceCard from "@/components/PerformanceCard.vue";
import { toggleLiveLike, toggleArtistLike } from "@/utils/write/user";
import { getUserInfo, getUserLikes } from "@/utils/read/user";
import { getMyTicketReservations } from "@/utils/read/ticket";
import { parse, isValid } from "date-fns";
import { trackMenuClick } from "@/utils/statistics";
// X API 관련 유틸리티는 컴포넌트 내부에서 직접 구현

export default {
  name: "MyProfile",
  components: {
    ProfileImageUploader,
    ArtistCard,
    ArtistCardModal,
    PerformanceCard,
  },
  data() {
    return {
      activeTab: "lives",
      profileImage: null,
      followerCount: 0,
      followingCount: 0,
      likedLives: [],
      likedArtists: [],
      loadingLives: true, // 초기 상태를 로딩 중으로 설정
      loadingArtists: false,
      userLiveLikes: [], // Firestore에서 가져온 찜한 공연 목록
      userArtistLikes: [], // Firestore에서 가져온 찜한 아티스트 목록
      livesLoaded: false, // 공연 데이터 로드 완료 여부
      artistsLoaded: false, // 아티스트 데이터 로드 완료 여부
      profileLoading: true, // 프로필 로딩 상태
      xConnecting: false, // X 연동 중 상태
      userDetailLink: null, // 사용자 상세 링크
      artistCardConnected: false, // 아티스트 카드 연동 여부
      artistCardModalVisible: false, // 아티스트 카드 모달 표시 여부
      unreadNotificationCount: 0, // 읽지 않은 알림 개수
      upcomingTicket: null, // 가장 빠른 예매 티켓
      loadingTicket: true, // 티켓 로딩 상태
    };
  },
  computed: {
    userStore() {
      return useUserStore();
    },
  },
  async created() {
    // 로그인 체크
    if (!this.userStore.isLogin) {
      this.$alert("로그인이 필요합니다");
      this.$router.push("/");
      return;
    }

    // X 연동 결과 확인 (모바일에서 sessionStorage로 전달된 경우)
    this.checkXConnectStatus();

    // 사용자 정보 동기화
    await this.userStore.syncUserData();

    // 컴포넌트 생성 즉시 로딩 시작 (DOM 생성 전)
    this.startDataLoading();
  },

  async activated() {
    // 페이지가 활성화될 때마다 프로필 데이터 강제 새로고침
    await this.forceRefreshProfile();
  },

  async mounted() {
    // DOM이 준비된 후 추가 작업이 필요한 경우
  },

  async beforeRouteEnter(to, from, next) {
    // 라우트 진입 시에도 프로필 새로고침 준비
    next((vm) => {
      // 컴포넌트가 생성된 후 실행
      if (vm.userStore.isLogin) {
        vm.$nextTick(() => {
          vm.forceRefreshProfile();
        });
      }
    });
  },

  async beforeRouteUpdate(to, from, next) {
    // 같은 컴포넌트 내에서 라우트가 변경될 때
    await this.forceRefreshProfile();
    next();
  },
  methods: {
    getUpcomingReservationStatusText(status) {
      const map = {
        pending: "대기중",
        confirmed: "확정",
        cancelled: "취소",
        refund_requested: "환불 요청",
        refund_completed: "환불 완료",
        refunded: "환불 완료",
      };
      return map[status] || "대기중";
    },
    // MyReservations와 동일한 통합 상태 키/텍스트 기준
    getUpcomingUnifiedStatusKey(r) {
      if (!r) return "pay_pending";
      if (r.status === "refund_completed") return "refund_completed";
      if (r.status === "refund_requested") return "refund_requested";
      if (r.status === "cancelled") return "cancelled";
      if (r.status === "confirmed") return "confirmed";
      if (r.paymentConfirmed) return "pay_confirmed";
      return "pay_pending";
    },
    getUpcomingUnifiedStatusText(r) {
      if (!r) return "입금 확인중";
      if (r.status === "refund_completed") return "환불 완료";
      if (r.status === "refund_requested") return "환불 대기중";
      if (r.status === "cancelled") return "취소됨";
      if (r.status === "confirmed") return "예매확정";
      if (r.paymentConfirmed) return "입금완료";
      return "입금 확인중";
    },
    async loadUpcomingTicket() {
      this.loadingTicket = true;
      const now = new Date();

      const parseLiveDate = (dateStr) => {
        if (!dateStr) return null;
        const temp = dateStr.replace(/\./g, "-").trim();
        const fmt = !temp.includes(":") ? temp + " 00:00" : temp;
        const d = parse(fmt, "yyyy-MM-dd HH:mm", new Date());
        return isValid(d) ? d : null;
      };

      const getPosterUrl = async (imgPath) => {
        if (!imgPath) return null;
        if (imgPath.startsWith("http")) return imgPath;
        try {
          const normalized = imgPath.includes("/") ? imgPath : `poster/${imgPath}`;
          return await getDownloadURL(storageRef(storage, normalized));
        } catch (e) {
          return null;
        }
      };

      // 포스터 URL을 비동기로 가져와 _posterUrl에 직접 반영
      const loadPosterAsync = (imgPath) => {
        if (!imgPath) return;
        getPosterUrl(imgPath).then((url) => {
          if (url && this.upcomingTicket) {
            this.upcomingTicket._posterUrl = url;
          }
        });
      };

      const fetchLivesByIds = async (ids) => {
        if (!ids.length) return [];
        const batchSize = 10;
        const docs = [];

        for (let i = 0; i < ids.length; i += batchSize) {
          const batch = ids.slice(i, i + batchSize);
          const liveQuery = query(
            collection(firestore, "lives"),
            where(documentId(), "in", batch)
          );
          const liveSnapshot = await getDocs(liveQuery);
          docs.push(...liveSnapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() })));
        }

        return docs;
      };

      const pickSoonestLive = (lives) =>
        lives
          .map((live) => ({ ...live, _dateObj: parseLiveDate(live.date) }))
          .filter((live) => live._dateObj && live._dateObj >= now)
          .sort((a, b) => a._dateObj - b._dateObj)[0] || null;

      try {
        // ── 1단계: 예매한 공연 (regId = 로그인 이메일, API 한 번 — MyReservations와 동일)
        const email = this.userStore.email;
        const allReservations = email ? await getMyTicketReservations(email) : [];

        if (allReservations.length) {
          const reservations = allReservations.filter(
            (reservation) => !["cancelled", "refund_completed", "refunded"].includes(reservation.status)
          );

          const reservedLiveIds = Array.from(
            new Set(reservations.map((reservation) => reservation.liveId).filter(Boolean))
          );
          const reservedLives = await fetchLivesByIds(reservedLiveIds);
          const reservedLiveMap = new Map(
            reservedLives.map((live) => [live.id, live])
          );

          const upcomingReservations = reservations
            .map((reservation) => {
              const live = reservedLiveMap.get(reservation.liveId);
              const liveDate = live?.date || reservation.liveDate || "";
              const dateObj = parseLiveDate(liveDate);
              if (!dateObj || dateObj < now) return null;

              return {
                ...reservation,
                _dateObj: dateObj,
                _resolvedTitle: live?.title || reservation.liveTitle || "공연",
                _resolvedDate: liveDate,
                _resolvedPlace: live?.place || reservation.livePlace || "",
                _resolvedImg: live?.img || live?.poster || reservation.liveImg || null,
              };
            })
            .filter(Boolean)
            .sort((a, b) => a._dateObj - b._dateObj);

          if (upcomingReservations.length) {
            const r = upcomingReservations[0];
            this.upcomingTicket = {
              _type: "reservation",
              _posterUrl: null,
              _title: r._resolvedTitle,
              _date: r._resolvedDate,
              _place: r._resolvedPlace,
              _liveId: r.liveId || null,
              status: r.status,
              paymentConfirmed: r.paymentConfirmed,
              quantity: r.quantity,
              isInviteTicket: !!r.isInviteTicket,
            };
            this.loadingTicket = false;
            loadPosterAsync(r._resolvedImg);
            return;
          }
        }

        // ── 2단계: 찜한 공연 중 가장 빠른 것 ──
        const likedIds = this.userLiveLikes || [];
        if (likedIds.length) {
          const likedLives = await fetchLivesByIds(likedIds);
          const likedUpcoming = pickSoonestLive(likedLives);

          if (likedUpcoming) {
            this.upcomingTicket = {
              _type: "liked",
              _posterUrl: null,
              _title: likedUpcoming.title || "공연",
              _date: likedUpcoming.date || "",
              _place: likedUpcoming.place || "",
              _liveId: likedUpcoming.id,
            };
            this.loadingTicket = false;
            loadPosterAsync(likedUpcoming.img || likedUpcoming.poster || null);
            return;
          }
        }

        // ── 3단계: 전체 공연 중 가장 빠른 것 ──
        const allSnap = await getDocs(collection(firestore, "lives"));
        const allUpcoming = pickSoonestLive(
          allSnap.docs.map((d) => ({ id: d.id, ...d.data() }))
        );

        if (allUpcoming) {
          this.upcomingTicket = {
            _type: "any",
            _posterUrl: null,
            _title: allUpcoming.title || "공연",
            _date: allUpcoming.date || "",
            _place: allUpcoming.place || "",
            _liveId: allUpcoming.id,
          };
          this.loadingTicket = false;
          loadPosterAsync(allUpcoming.img || allUpcoming.poster || null);
          return;
        }

        this.upcomingTicket = null;
      } catch (e) {
        console.warn("다가오는 공연 로드 오류:", e);
        this.upcomingTicket = null;
      } finally {
        this.loadingTicket = false;
      }
    },

    // X 연동 상태 확인 (모바일에서 sessionStorage로 전달된 경우)
    checkXConnectStatus() {
      const status = sessionStorage.getItem("x_connect_status");
      const message = sessionStorage.getItem("x_connect_message");

      if (status && message) {
        // sessionStorage 정리
        sessionStorage.removeItem("x_connect_status");
        sessionStorage.removeItem("x_connect_message");

        // xConnecting 상태 해제
        this.xConnecting = false;

        if (status === "success") {
          // 성공 메시지 표시 후 프로필 데이터 새로고침
          this.$alert(message).then(() => {
            this.forceRefreshProfile();
          });
        } else if (status === "error") {
          // 실패 메시지 표시
          this.$alert(`X 연동 실패: ${message}`);
        }
      }
    },

    async startDataLoading() {
      try {
        // 프로필 데이터와 사용자 찜 데이터를 병렬로 로드
        await Promise.all([
          this.loadProfileData(),
          this.loadUserLikes(),
          this.loadUnreadNotificationCount(),
        ]);

        // 프로필 로딩 완료
        this.profileLoading = false;

        // 찜 목록이 로드된 뒤 다가오는 공연 로드 (폴백으로 userLiveLikes 사용)
        this.loadUpcomingTicket();

        // 초기 탭(공연)의 데이터 로드
        if (this.activeTab === "lives") {
          await this.loadLikedLives();
          this.livesLoaded = true;
        }
      } catch (error) {
        console.error("데이터 로딩 오류:", error);
        this.profileLoading = false;
        this.loadingLives = false;
      }
    },

    async switchTab(tab) {
      this.activeTab = tab;

      // 해당 탭의 데이터가 아직 로드되지 않았다면 로드
      if (tab === "lives" && !this.livesLoaded) {
        await this.loadLikedLives();
        this.livesLoaded = true;
      } else if (tab === "artists" && !this.artistsLoaded) {
        await this.loadLikedArtists();
        this.artistsLoaded = true;
      }
    },
    async loadProfileData() {
      // 사용자 프로필 이미지 로드
      await this.loadUserProfileImage();
      // 팔로워/팔로잉 수 로드 (나중에 Firestore에서 가져올 수 있음)
      // this.followerCount = await this.getFollowerCount();
      // this.followingCount = await this.getFollowingCount();
    },

    async forceRefreshProfile() {
      // 프로필 화면에 들어올 때마다 강제로 프로필 정보 새로고침
      if (!this.userStore.isLogin) return;

      try {
        // 사용자 정보 동기화
        await this.userStore.syncUserData();

        // 프로필 이미지 강제 새로고침
        await this.loadUserProfileImage();

        // 닉네임도 Firestore에서 다시 가져와서 store 업데이트
        const userData = await getUserInfo(this.userStore.email);

        if (userData) {
          if (userData.nickname && userData.nickname !== this.userStore.nickname) {
            this.userStore.setNickname(userData.nickname);
          }

          // detailLink 업데이트
          this.userDetailLink = userData.detailLink || null;

          // 아티스트 카드 연동 상태 확인
          await this.checkArtistCardConnection();
        }

        // 읽지 않은 알림 개수 새로고침
        await this.loadUnreadNotificationCount();
      } catch (error) {
        console.warn("프로필 강제 새로고침 오류:", error);
      }
    },

    async loadUserProfileImage() {
      if (!this.userStore.isLogin) {
        return;
      }

      try {
        // Firestore에서 사용자 데이터 가져오기
        const userData = await getUserInfo(this.userStore.email);

        if (userData) {
          // 프로필 이미지가 있으면 다운로드 URL 생성
          if (userData.img) {
            try {
              const imageRef = storageRef(storage, `profile/${userData.img}`);
              this.profileImage = await getDownloadURL(imageRef);
              // Store의 프로필 이미지도 업데이트
              this.userStore.setProfileImage(this.profileImage);
            } catch (error) {
              console.warn("프로필 이미지 URL 생성 실패:", error);
              this.profileImage = null;
              this.userStore.setProfileImage(null);
            }
          } else {
            this.profileImage = null;
            this.userStore.setProfileImage(null);
          }

          // detailLink 로드
          this.userDetailLink = userData.detailLink || null;

          // 아티스트 카드 연동 상태 확인
          await this.checkArtistCardConnection();
        }
      } catch (error) {
        console.error("사용자 프로필 이미지 로드 오류:", error);
        this.profileImage = null;
      }
    },

    // 프로필 이미지 업데이트 핸들러
    handleImageUpdated(url) {
      this.profileImage = url;
      // Store의 프로필 이미지도 업데이트
      this.userStore.setProfileImage(url);
    },

    // 프로필 이미지 삭제 핸들러
    async handleImageRemoved() {
      this.profileImage = null;
      // Store의 프로필 이미지도 삭제
      this.userStore.setProfileImage(null);

      // 프로필 이미지 다시 로드하여 화면 업데이트 확실히 하기
      await this.$nextTick();
      await this.loadUserProfileImage();
    },

    async loadUserLikes() {
      if (!this.userStore.isLogin) {
        return;
      }

      try {
        // API를 통해 사용자 찜 데이터 가져오기
        const userLikes = await getUserLikes(this.userStore.email);
        this.userLiveLikes = userLikes.liveLikes || [];
        this.userArtistLikes = userLikes.artistLikes || [];
      } catch (error) {
        console.error("사용자 찜 데이터 로드 오류:", error);
        this.userLiveLikes = [];
        this.userArtistLikes = [];
      }
    },

    async loadLikedLives() {
      if (!this.userStore.isLogin || this.userLiveLikes.length === 0) {
        this.likedLives = [];
        this.loadingLives = false;
        return;
      }

      try {
        this.loadingLives = true;

        // Firestore IN 쿼리 제한 (최대 10개)을 고려하여 배치 처리
        const batchSize = 10;
        const livesData = [];

        for (let i = 0; i < this.userLiveLikes.length; i += batchSize) {
          const batch = this.userLiveLikes.slice(i, i + batchSize);

          // 특정 ID들만 쿼리로 가져오기 (전체 컬렉션 스캔 방지)
          const livesQuery = query(
            collection(firestore, "lives"),
            where(documentId(), "in", batch)
          );

          const livesSnapshot = await getDocs(livesQuery);

          // 이미지 URL은 백그라운드로 해결 (여기서는 파일명만 보관)
          const batchData = livesSnapshot.docs.map((doc) => {
            const liveData = doc.data();
            return {
              id: doc.id,
              title: liveData.title,
              rawDate: liveData.date,
              date: this.formatDate(liveData.date),
              place: liveData.place,
              poster: null,
              _posterFile: liveData.img || null,
            };
          });

          livesData.push(...batchData);
        }

        // 날짜순으로 정렬 (최신순) - LinkookLiveTiles와 동일한 방식
        this.likedLives = livesData.sort((a, b) => {
          // 날짜가 없는 경우 처리
          if (!a.rawDate && !b.rawDate) return 0;
          if (!a.rawDate) return 1;
          if (!b.rawDate) return -1;

          // LinkookLiveTiles와 동일한 날짜 파싱 방식
          const parseDate = (dateStr) => {
            const tempDateStr = dateStr.replace(/\./g, "-").trim(); // 점(.)을 대시(-)로 변경
            const formattedDateStr = !tempDateStr.includes(":") // 시간이 없는 경우 기본값 " 00:00" 추가
              ? tempDateStr + " 00:00"
              : tempDateStr;
            return parse(formattedDateStr, "yyyy-MM-dd HH:mm", new Date());
          };

          const dateA = parseDate(a.rawDate);
          const dateB = parseDate(b.rawDate);

          // 날짜가 유효한지 확인 (Invalid Date 방지)
          if (!isValid(dateA) || !isValid(dateB)) {
            if (!isValid(dateA) && !isValid(dateB)) return 0;
            if (!isValid(dateA)) return 1;
            return -1;
          }

          // 날짜 부분만 비교 (시간 제외) - LinkookLiveTiles 방식
          const getDateOnly = (date) => {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
          };
          const dateOnlyA = getDateOnly(dateA);
          const dateOnlyB = getDateOnly(dateB);

          // 최신순 정렬 (b.date - a.date)
          return dateOnlyB.getTime() - dateOnlyA.getTime();
        });

        // 포스터 이미지는 백그라운드로 (카드 표시는 즉시, 이미지는 개별 카드 단위로 차차 채워짐)
        this.resolveLikedLivePosters();
      } catch (error) {
        console.error("찜한 공연 로드 오류:", error);
      } finally {
        this.loadingLives = false;
      }
    },

    resolveLikedLivePosters() {
      this.likedLives.forEach(async (live) => {
        if (!live._posterFile || live.poster) return;
        try {
          const posterRef = storageRef(storage, `poster/${live._posterFile}`);
          live.poster = await getDownloadURL(posterRef);
        } catch (error) {
          // 실패 시 null 유지
        }
      });
    },

    async loadLikedArtists() {
      if (!this.userStore.isLogin || this.userArtistLikes.length === 0) {
        this.likedArtists = [];
        this.loadingArtists = false;
        return;
      }

      try {
        this.loadingArtists = true;

        // 1. 아티스트 정보 가져오기
        const batchSize = 10;
        const artistsData = [];

        for (let i = 0; i < this.userArtistLikes.length; i += batchSize) {
          const batch = this.userArtistLikes.slice(i, i + batchSize);

          // 특정 아티스트 ID들만 쿼리로 가져오기
          const artistsQuery = query(collection(firestore, "artists"), where(documentId(), "in", batch));
          const artistsSnapshot = await getDocs(artistsQuery);

          // 이미지 URL은 백그라운드로 해결 (여기서는 파일 경로만 계산해 보관)
          const batchData = artistsSnapshot.docs.map((doc) => {
            const artistData = doc.data();
            let imagePath = null;
            if (artistData.userProfileImg) {
              imagePath = `profile/${artistData.userProfileImg}`;
            } else if (artistData.img) {
              imagePath = `artist/${artistData.img}`;
            }

            return {
              id: doc.id,
              slug: artistData.slug ?? null,
              name: artistData.name,
              type: artistData.type || null,
              profileImage: null,
              _imagePath: imagePath,
              lastPerformanceDate: null,
            };
          });

          artistsData.push(...batchData);
        }

        // 2. 모든 공연 데이터 가져와서 각 아티스트의 최근 공연 날짜 찾기
        const livesSnapshot = await getDocs(collection(firestore, "lives"));

        // 각 아티스트별 최근 공연 날짜 계산
        artistsData.forEach((artist) => {
          let latestDate = null;

          livesSnapshot.docs.forEach((liveDoc) => {
            const liveData = liveDoc.data();
            const lineup = liveData.lineup || [];

            // 이 공연에 해당 아티스트가 출연했는지 확인
            if (Array.isArray(lineup) && lineup.includes(artist.name)) {
              // LinkookLiveTiles와 동일한 날짜 파싱 방식
              if (liveData.date) {
                const parseDate = (dateStr) => {
                  const tempDateStr = dateStr.replace(/\./g, "-").trim(); // 점(.)을 대시(-)로 변경
                  const formattedDateStr = !tempDateStr.includes(":") // 시간이 없는 경우 기본값 " 00:00" 추가
                    ? tempDateStr + " 00:00"
                    : tempDateStr;
                  return parse(formattedDateStr, "yyyy-MM-dd HH:mm", new Date());
                };

                const liveDate = parseDate(liveData.date);

                if (isValid(liveDate)) {
                  if (!latestDate || liveDate > latestDate) {
                    latestDate = liveDate;
                  }
                }
              }
            }
          });

          artist.lastPerformanceDate = latestDate;
        });

        // 3. 최근 공연한 순으로 정렬 (최근 공연한 아티스트가 위로) - LinkookLiveTiles와 동일한 방식
        this.likedArtists = artistsData.sort((a, b) => {
          // 둘 다 공연 이력이 있는 경우
          if (a.lastPerformanceDate && b.lastPerformanceDate) {
            // 날짜 부분만 비교 (시간 제외) - LinkookLiveTiles 방식
            const getDateOnly = (date) => {
              return new Date(date.getFullYear(), date.getMonth(), date.getDate());
            };
            const dateOnlyA = getDateOnly(a.lastPerformanceDate);
            const dateOnlyB = getDateOnly(b.lastPerformanceDate);
            return dateOnlyB.getTime() - dateOnlyA.getTime();
          }

          // 한쪽만 공연 이력이 있는 경우 (공연 이력이 있는 것을 위로)
          if (a.lastPerformanceDate && !b.lastPerformanceDate) {
            return -1;
          }
          if (!a.lastPerformanceDate && b.lastPerformanceDate) {
            return 1;
          }

          // 둘 다 공연 이력이 없는 경우 이름순 정렬
          return a.name.localeCompare(b.name);
        });

        // 프로필 이미지는 백그라운드로 (카드 표시는 즉시, 이미지는 개별 카드 단위로 차차 채워짐)
        this.resolveLikedArtistImages();
      } catch (error) {
        console.error("찜한 아티스트 로드 오류:", error);
      } finally {
        this.loadingArtists = false;
      }
    },

    resolveLikedArtistImages() {
      this.likedArtists.forEach(async (artist) => {
        if (!artist._imagePath || artist.profileImage) return;
        try {
          const imageRef = storageRef(storage, artist._imagePath);
          artist.profileImage = await getDownloadURL(imageRef);
        } catch (error) {
          console.warn(`프로필 이미지 URL 생성 실패 (${artist.name}):`, error);
        }
      });
    },

    async unlikeLive(liveId) {
      try {
        // Firestore에서 공연 찜 해제 (현재 찜 상태 = true)
        await toggleLiveLike(liveId, this.userStore.email, true);

        // 로컬 상태 업데이트
        this.userLiveLikes = this.userLiveLikes.filter((id) => id !== liveId);

        // UI에서 제거
        this.likedLives = this.likedLives.filter((live) => live.id !== liveId);

        // 공연 찜 해제 완료
      } catch (error) {
        console.error("공연 찜 해제 오류:", error);
        this.$alert("오류가 발생했습니다. 다시 시도해주세요.");
      }
    },

    async unlikeArtist(artistId) {
      try {
        // Firestore에서 아티스트 찜 해제 - 양방향 업데이트 (현재 찜 상태 = true)
        await toggleArtistLike(artistId, this.userStore.email, true);

        // 로컬 상태 업데이트
        this.userArtistLikes = this.userArtistLikes.filter((id) => id !== artistId);

        // UI에서 제거
        this.likedArtists = this.likedArtists.filter((artist) => artist.id !== artistId);

        // 아티스트 찜 해제 완료
      } catch (error) {
        console.error("아티스트 찜 해제 오류:", error);
        this.$alert("오류가 발생했습니다. 다시 시도해주세요.");
      }
    },

    goToLiveDetail(liveId) {
      this.$router.push(`/live/${liveId}`);
    },

    shareProfile() {
      if (navigator.share) {
        navigator.share({
          title: `${this.userStore.nickname}의 프로필`,
          text: `${this.userStore.nickname}의 프로필을 확인해보세요!`,
          url: window.location.href,
        });
      } else {
        // 클립보드에 복사
        navigator.clipboard.writeText(window.location.href).then(() => {
          this.$alert("프로필 링크가 클립보드에 복사되었습니다.");
        });
      }
    },

    editProfile() {
      // 프로필 수정 모달이나 페이지로 이동
      this.userStore.nicknamePopup = true;
    },

    async connectX() {
      if (!process.env.VUE_APP_X_CLIENT_ID) {
        console.error("X Client ID가 설정되지 않았습니다.");
        this.$alert("X 연동이 설정되지 않았습니다.");
        return;
      }

      try {
        this.xConnecting = true;

        // 기존 X 연동 데이터 정리 (충돌 방지)
        document.cookie = "x_state=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "x_auth_type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "x_code_verifier=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

        // localStorage 저장 완료를 확실히 하기 위한 짧은 딜레이
        await new Promise((resolve) => setTimeout(resolve, 1000));

        const codeVerifier = this.generateCodeVerifier();
        const codeChallenge = await this.generateCodeChallenge(codeVerifier);
        const state = this.generateRandomString(32);

        // 쿠키에 OAuth 데이터 저장 (30분 유효)
        const expireTime = new Date(Date.now() + 30 * 60 * 1000);

        document.cookie = `x_code_verifier=${encodeURIComponent(
          codeVerifier
        )}; expires=${expireTime.toUTCString()}; path=/; SameSite=Lax`;
        document.cookie = `x_state=${encodeURIComponent(
          state
        )}; expires=${expireTime.toUTCString()}; path=/; SameSite=Lax`;
        document.cookie = `x_auth_type=profile; expires=${expireTime.toUTCString()}; path=/; SameSite=Lax`;

        // 쿠키 저장 완료 대기
        await new Promise((resolve) => setTimeout(resolve, 100));

        // 쿠키 저장 확인
        const cookieVerifyCodeVerifier = this.getCookie("x_code_verifier");
        const cookieVerifyState = this.getCookie("x_state");
        const cookieVerifyAuthType = this.getCookie("x_auth_type");

        if (!cookieVerifyCodeVerifier || !cookieVerifyState || !cookieVerifyAuthType) {
          throw new Error("쿠키 저장에 실패했습니다.");
        }

        const params = new URLSearchParams({
          response_type: "code",
          client_id: process.env.VUE_APP_X_CLIENT_ID,
          redirect_uri: `${window.location.origin}/x-callback`,
          scope: "tweet.read users.read offline.access",
          state: state,
          code_challenge: codeChallenge,
          code_challenge_method: "S256",
        });

        const authUrl = `https://x.com/i/oauth2/authorize?${params.toString()}`;

        // 모바일 감지
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );

        if (isMobile) {
          // 모바일에서는 전체 페이지 리다이렉트
          window.location.href = authUrl;
        } else {
          // 데스크톱에서는 팝업 사용
          const popup = window.open(
            authUrl,
            "x_auth",
            "width=500,height=600,scrollbars=yes,resizable=yes"
          );

          if (!popup) {
            // 팝업이 차단된 경우
            this.$alert("팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.");
            this.xConnecting = false;
            return;
          }

          const messageHandler = (event) => {
            if (event.origin !== window.location.origin) return;

            if (event.data.type === "X_CONNECT_SUCCESS") {
              this.xConnecting = false;
              this.$alert(event.data.message).then(() => window.location.reload());
              window.removeEventListener("message", messageHandler);
              document.cookie = "x_auth_type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            } else if (event.data.type === "X_CONNECT_ERROR") {
              this.xConnecting = false;
              this.$alert(`X 연동 실패: ${event.data.message}`);
              window.removeEventListener("message", messageHandler);
              document.cookie = "x_auth_type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }
          };

          window.addEventListener("message", messageHandler);

          const checkClosed = setInterval(() => {
            if (popup.closed) {
              clearInterval(checkClosed);
              setTimeout(() => {
                if (this.xConnecting) {
                  this.xConnecting = false;
                  this.$alert("X 연동이 취소되었습니다.");
                  window.removeEventListener("message", messageHandler);
                  document.cookie = "x_auth_type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                }
              }, 1000);
            }
          }, 1000);
        }
      } catch (error) {
        this.$alert("X 연동 중 오류가 발생했습니다.");
        this.xConnecting = false;
      }
    },

    generateCodeVerifier() {
      const array = new Uint8Array(32);
      crypto.getRandomValues(array);
      return this.base64URLEncode(array);
    },

    async generateCodeChallenge(codeVerifier) {
      const encoder = new TextEncoder();
      const data = encoder.encode(codeVerifier);
      const digest = await crypto.subtle.digest("SHA-256", data);
      return this.base64URLEncode(new Uint8Array(digest));
    },

    base64URLEncode(array) {
      return btoa(String.fromCharCode.apply(null, array))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");
    },

    generateRandomString(length) {
      const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
      let result = "";
      const values = crypto.getRandomValues(new Uint8Array(length));
      values.forEach((value) => {
        result += charset[value % charset.length];
      });
      return result;
    },

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        return decodeURIComponent(parts.pop().split(";").shift());
      }
      return null;
    },

    openArtistCardModal() {
      this.artistCardModalVisible = true;
    },

    closeArtistCardModal() {
      this.artistCardModalVisible = false;
    },

    async handleArtistCardUpdated() {
      // 아티스트 카드가 업데이트되었을 때 연동 상태 다시 확인
      await this.checkArtistCardConnection();
    },

    async checkArtistCardConnection() {
      if (!this.userDetailLink) {
        this.artistCardConnected = false;
        return;
      }

      try {
        // 모든 아티스트에서 현재 사용자의 detailLink와 같은 것이 있는지 확인
        const artistsQuery = query(
          collection(firestore, "artists"),
          where("detailLink", "==", this.userDetailLink)
        );

        const artistsSnapshot = await getDocs(artistsQuery);
        this.artistCardConnected = !artistsSnapshot.empty;
      } catch (error) {
        console.error("아티스트 카드 연동 상태 확인 오류:", error);
        this.artistCardConnected = false;
      }
    },

    formatDate(date) {
      if (!date) return "날짜 정보 없음";

      try {
        // LinkookLiveTiles와 동일한 날짜 파싱 방식
        const parseDate = (dateStr) => {
          const tempDateStr = dateStr.replace(/\./g, "-").trim(); // 점(.)을 대시(-)로 변경
          const formattedDateStr = !tempDateStr.includes(":") // 시간이 없는 경우 기본값 " 00:00" 추가
            ? tempDateStr + " 00:00"
            : tempDateStr;
          return parse(formattedDateStr, "yyyy-MM-dd HH:mm", new Date());
        };

        let dateObj;
        if (date instanceof Date) {
          dateObj = date;
        } else {
          dateObj = parseDate(date);
        }

        // 날짜가 유효한지 확인 (Invalid Date 방지)
        if (!isValid(dateObj)) {
          return "날짜 정보 없음";
        }

        return dateObj.toLocaleDateString("ko-KR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      } catch (error) {
        return "날짜 정보 없음";
      }
    },

    async loadUnreadNotificationCount() {
      if (!this.userStore.isLogin) {
        this.unreadNotificationCount = 0;
        return;
      }

      try {
        const notificationsRef = collection(firestore, "alarms");
        const q = query(
          notificationsRef,
          where("userId", "==", this.userStore.email),
          where("read", "==", false)
        );

        const querySnapshot = await getDocs(q);
        this.unreadNotificationCount = querySnapshot.size;
      } catch (error) {
        console.error("읽지 않은 알림 개수 로드 오류:", error);
        this.unreadNotificationCount = 0;
      }
    },

    goToNotifications() {
      trackMenuClick("notifications");
      this.$router.push("/notifications");
    },
    goToCalendar() {
      trackMenuClick("calendar");
      this.$router.push("/my-calendar");
    },
    goToMyInfo() {
      trackMenuClick("myInfo");
      this.$router.push("/my-info");
    },
  },
};
</script>

<style module>
/* Medium: 481px ~ (기본 스타일, 최대 1024px) */
.container {
  width: 90%;
  min-height: 100vh;
  margin: 0 auto;
  padding: 0;
}

.pageHeader {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 6px 0 4px;
  border-bottom: 1px solid #efefef;
}

.pageHeaderLeft {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pageHeaderRight {
  display: flex;
  align-items: center;
  gap: 2px;
}

.headerBackButton {
  background: transparent;
  border: none;
  cursor: pointer;
  width: 36px;
  height: 36px;
  font-size: 20px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.15s;
  flex-shrink: 0;
}

.headerBackButton:hover {
  background: #f5f5f5;
}

.pageTitle {
  margin: 0;
  font-size: 19px;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-weight: 700;
  color: #111;
  letter-spacing: -0.3px;
}

.headerIconButton {
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.15s;
}

.headerIconButton:hover {
  background: #f5f5f5;
}

.headerIconImg {
  width: 22px;
  height: 22px;
  display: block;
}

.headerAlarmBadge {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 7px;
  height: 7px;
  background: #ff3b30;
  border-radius: 50%;
  border: 1.5px solid #fff;
}

.profileCard {
  background: white;
  padding: 20px 20px;
  text-align: left;
}

.profileMainRow {
  display: flex;
  align-items: center;
  gap: 22px;
  margin: 10px 0;
  margin-bottom: 30px;
  border-radius: 10px;
}

.profileImageColumn {
  flex-shrink: 0;
}

.profileInfoColumn {
  width: 100%;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.profileActionColumn {
  width: 220px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 10px;
}

.profileActionSkeletonWrap {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  align-self: center;
  flex-shrink: 0;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}


.username {
  font-size: 1.75rem;
  font-weight: bold;
  color: #333;
  margin: 0 0 10px 0;
  font-family: "NanumSquareRoundEB", "NanumSquareRoundB", sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
}

.editNicknameButton {
  border: none;
  background: transparent;
  padding: 6px;
  margin: 0;
  cursor: pointer;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease, transform 0.2s ease;
}

.editNicknameButton:hover {
  background: rgba(102, 189, 255, 0.15);
  transform: translateY(-1px);
}

.editNicknameButton:active {
  transform: translateY(0);
}

.editNicknameIcon {
  width: 18px;
  height: 18px;
  fill: #6b7280;
}

.handleContainer {
  display: block;
  margin-bottom: 8px;
}

.handleIcon {
  font-size: 16px;
  color: #666;
}

.handle {
  font-size: 1rem;
  color: #666;
  font-family: "NanumSquareRoundR", sans-serif;
}

.detailLinkButton {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 5px 12px;
  background: #111;
  color: #fff;
  border-radius: 8px;
  font-size: 0.78rem;
  font-family: "NanumSquareRoundR", sans-serif;
  text-decoration: none;
  max-width: 220px;
  overflow: hidden;
  transition: background 0.2s ease;
}

.detailLinkButton span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detailLinkButton:hover {
  background: #333;
}

.detailLinkXIcon {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  display: block;
}

.followInfo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 30px;
  font-size: 0.9rem;
  color: #666;
  font-family: "NanumSquareRoundR", sans-serif;
}

.separator {
  color: #ccc;
}

.blockedMessage {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  color: #c62828;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  text-align: center;
  border: 1px solid #ef9a9a;
}

.buttonContainer {
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  flex-wrap: nowrap;
}

.bottomActionContainer {
  margin-top: 14px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.bottomActionContainer .actionButton {
  width: auto;
  min-width: 140px;
}

.actionButton {
  width: 44px;
  height: 44px;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: "NanumSquareRoundR", sans-serif;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;

}

.actionButton:hover {
  background: #e9ecef;
  transform: translateY(-1px);
}

.actionButton:active {
  transform: translateY(0);
}

.infoListActionButton {
  width: 100%;
  height: 36px;
  border-radius: 0;
  justify-content: right;
  padding: 0;
  background: transparent;
  border: none;
  color: #4f4f4f;
  font-size: 0.9rem;
  font-weight: 600;
}

.infoListActionButton:hover,
.infoListActionButton:active {
  background: transparent;
  transform: none;
}

.chevronIcon {
  color: #b2b2b2;
  font-size: 20px;
  line-height: 1;
  margin-right: 10px;
}

.xButton {
  background: #000000;
  color: white;
  border-color: #000000;
}

.xButton:hover {
  background: #333333;
  border-color: #333333;
}

.xButton:disabled {
  background: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
  transform: none;
}

.xIcon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
}

.artistCardButton {
  background: linear-gradient(135deg, #66bdff, #ff6ba9);
  color: white;
  border: none;
}

.artistCardButton:hover {
  background: linear-gradient(135deg, #4a9eff, #ff4d94);
  transform: translateY(-1px);
}

.artistCardButton:disabled {
  background: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
  transform: none;
}

/* 탭 구조 */
.tabContainer {
  background: white;
  /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); */
  overflow: hidden;
}

.tabHeader {
  display: flex;
  margin: 0px 20px;
}

.tabButton {
  flex: 1;
  padding: 18px;
  background: none;
  border: none;
  border-radius: 10px;
  /* margin: 0px 10px; */
  font-size: 1.05rem;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: "NanumSquareRoundR", sans-serif;
}

.tabButton:hover {
  background: #f8f9fa;
  color: #333;
}

.tabButton.activeTab {
  background: #66bdff;
  color: white;
  font-weight: 600;
}

.tabContent {
  padding: 20px;
  min-height: 300px;
}

/* 로딩 상태 */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #66bdff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* 빈 상태 */
.emptyState {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.emptyIcon {
  font-size: 48px;
  margin-bottom: 20px;
}

.emptyState h3 {
  margin: 0 0 10px 0;
  font-size: 1.2rem;
  color: #333;
}

.emptyState p {
  margin: 0;
  font-size: 0.9rem;
}

/* 라이브 리스트 */
.liveList {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
}

/* 아티스트 리스트 */
.artistList {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 16px;
}

/* 스켈레톤 UI */
.profileImageSkeleton {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin: 0 auto 20px;
}

.usernameSkeleton {
  width: 130px;
  height: 24px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 6px;
  margin: 0 0 10px;
}

.handleSkeleton {
  width: 170px;
  height: 14px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 6px;
  margin: 0 0 8px;
}

.upcomingSectionSkeleton {
  margin: 16px 0 4px;
  padding: 0;
}

.upcomingTitleSkeleton {
  width: 100px;
  height: 17px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin: 0 5px 14px;
}

.upcomingCardSkeleton {
  height: 92px;
  border-radius: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
}

.tabHeaderSkeleton {
  display: flex;
  margin: 0px 20px;
  gap: 0;
}

.tabButtonSkeleton {
  flex: 1;
  height: 60px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 10px;
  margin: 0px 5px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}

/* ========================================
   Small (~480px)
   ======================================== */
@media screen and (max-width: 480px) {
  .container {
    width: 100%;
    padding: 0;
  }

  .profileCard {
    padding: 20px 20px 20px 20px;
    text-align: left;
  }

  .profileMainRow {
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }

  .profileInfoColumn {
    align-items: flex-start;
  }

  .profileActionColumn {
    width: 110px;
  }

  .profileActionSkeletonWrap {
    width: 28px;
    height: 28px;
  }

  .usernameSkeleton {
    width: 100px;
    height: 18px;
  }

  .handleSkeleton {
    width: 140px;
    height: 12px;
  }

  .username {
    font-size: 1.1rem;
  }

  .handle {
    font-size: 0.72rem;
  }

  .detailLink {
    font-size: 0.72rem;
    max-width: 130px;
  }

  .buttonContainer {
    flex-direction: column;
    gap: 10px;
  }

  .bottomActionContainer {
    justify-content: center;
    flex-direction: column;
  }

  .bottomActionContainer .actionButton {
    width: 100%;
    min-width: 0;
  }

  .actionButton {
    width: 100%;
    height: 36px;
    font-size: 0.72rem;
    padding: 8px 6px;
    border-radius: 10px;
  }

  .username {
    justify-content: flex-start;
  }

  .detailLinkButton {
    max-width: 160px;
    font-size: 0.72rem;
  }

  .detailLinkXIcon {
    width: 11px;
    height: 11px;
  }

  .artistCardButton {
    font-size: 0.72rem;
    padding: 8px 6px;
  }

  .infoListActionButton {
    width: 100%;
    height: 36px;
    font-size: 0.74rem;
    padding: 0 10px;
  }

  .chevronIcon {
    font-size: 16px;
  }

  .xButton {
    font-size: 0.7rem;
    padding: 8px 6px;
  }

  .xIcon {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  .liveList {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .artistList {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .tabButton {
    padding: 15px;
    font-size: 1rem;
  }

  .emptyState {
    padding: 40px 20px;
  }

  .emptyIcon {
    font-size: 40px;
    margin-bottom: 16px;
  }

  .emptyState h3 {
    font-size: 1.1rem;
  }

  .emptyState p {
    font-size: 0.85rem;
  }

  .upcomingSectionTitle {
    font-size: 15px;
  }

  .upcomingMoreButton {
    font-size: 12px;
  }

  .upcomingTicketCard {
    padding: 8px;
    gap: 12px;
    border-radius: 10px;
  }

  .upcomingTitleSkeleton {
    width: 90px;
    height: 15px;
    margin: 0 5px 10px;
  }

  .upcomingCardSkeleton {
    height: 72px;
    border-radius: 10px;
  }

  .upcomingTicketSkeleton {
    height: 72px;
    border-radius: 0;
  }

  .upcomingPoster {
    width: 48px;
    height: 60px;
    border-radius: 6px;
  }

  .upcomingPosterEmpty {
    font-size: 22px;
  }

  .upcomingTicketInfo {
    gap: 3px;
  }

  .upcomingTicketTitle {
    font-size: 14px;
  }

  .upcomingTicketMeta {
    font-size: 12px;
  }

  .upcomingStatusBadge,
  .upcomingPayBadge,
  .upcomingQty {
    font-size: 11px;
    padding: 2px 7px;
  }

  .upcomingChevron {
    font-size: 18px;
  }

  .upcomingEmpty {
    font-size: 13px;
    padding: 10px 20px;
  }
}

/* ── 내 예매 공연 섹션 ── */
.upcomingSection {
  margin: 16px 0 4px;
  padding: 0;
}

.upcomingSectionHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 0 5px;
}

.upcomingSectionTitle {
  margin: 0;
  font-size: 17px;
  font-family: "Paperlogy7", sans-serif;
  font-weight: 700;
  color: #222;
}

.upcomingMoreButton {
  background: none;
  border: none;
  font-size: 13px;
  color: #aaa;
  cursor: pointer;
  font-family: "NanumSquareRoundR", sans-serif;
  padding: 0;
}

.upcomingMoreButton:hover {
  color: #555;
}

.upcomingTicketSkeleton {
  height: 92px;
  border-radius: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

.upcomingTicketCard {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  border: 1px solid #efefef;
  border-radius: 12px;
  padding: 8px;
  cursor: pointer;
  transition: background 0.15s;
}

.upcomingTicketCard:hover {
  background: #fafafa;
}

.upcomingPoster {
  width: 58px;
  height: 72px;
  border-radius: 8px;
  background-color: #e9e9e9;
  flex-shrink: 0;
  object-fit: cover;
  display: block;
}

.upcomingPosterEmpty {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  background-color: #f5f5f5;
}

.upcomingTicketInfo {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.upcomingTicketTitle {
  font-size: 16px;
  font-family: "NanumSquareRoundB", sans-serif;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.upcomingTicketMeta {
  font-size: 13px;
  color: #888;
  font-family: "NanumSquareRoundR", sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.upcomingDot {
  margin: 0 4px;
}

.upcomingBadgeRow {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

.upcomingStatusBadge,
.upcomingPayBadge,
.upcomingQty {
  font-size: 12px;
  padding: 3px 9px;
  border-radius: 20px;
  font-family: "NanumSquareRoundR", sans-serif;
}

.badge_pending {
  background: #fff3cd;
  color: #856404;
}

.badge_confirmed {
  background: #d1f5e0;
  color: #1a7a45;
}

.badge_cancelled {
  background: #f8d7da;
  color: #842029;
}

.badge_invite {
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.12) 0%, rgba(91, 33, 182, 0.12) 100%);
  color: #6d28d9;
  border: 1px solid rgba(124, 58, 237, 0.3);
}

.badge_liked {
  background: #ffeef2;
  color: #c0395a;
}

.badge_any {
  background: #f0f0f0;
  color: #666;
}

/* MyReservations와 동일한 통합 상태 배지 스타일 */
.pending {
  background: #fff9e6;
  color: #996c00;
  border: 1px solid #ffe8a1;
}

.confirmed {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
}

.cancelled {
  background: #fce4ec;
  color: #c62828;
  border: 1px solid #f8bbd0;
}

.refund_requested {
  background: rgba(102, 189, 255, 0.1);
  color: #1a6fa8;
  border: 1px solid rgba(102, 189, 255, 0.4);
}

.refund_completed {
  background: #e8eaf6;
  color: #3949ab;
  border: 1px solid #9fa8da;
}

.pay_confirmed {
  background: rgba(102, 187, 106, 0.12);
  color: #2e7d32;
  border: 1px solid rgba(102, 187, 106, 0.35);
}

.pay_pending {
  background: #f8f9fa;
  color: #868e96;
  border: 1px solid #e9ecef;
}

.payConfirmed {
  background: #e3f2fd;
  color: #1565c0;
}

.payPending {
  background: #f5f5f5;
  color: #777;
}

.upcomingQty {
  background: #f5f5f5;
  color: #555;
}

.upcomingChevron {
  font-size: 22px;
  color: #ccc;
  flex-shrink: 0;
}

.upcomingEmpty {
  font-size: 14px;
  color: #aaa;
  font-family: "NanumSquareRoundR", sans-serif;
  padding: 14px 24px;
  text-align: center;
}
</style>
